import React, { Fragment as F, Children, Component } from 'react';
import styles from './FieldGroup.css';

export default class FieldGroup extends Component {
	render() {
		const { className, isSlim, children, shift, ...props } = this.props;

		const classes = [];
		classes.push(styles.fieldGroup);

		if (isSlim) {
			classes.push(styles.fieldGroup_slim);
		}

		if (className) {
			classes.push(className);
		}

		return (
			<ul className={classes.join(' ')} {...props}>
				{Children.toArray(children).map((item, i) => (
					<li
						key={item.key || i}
						className={[styles.fieldGroup__item, shift ? styles.shift : ''].join(' ')}>
						{item}
					</li>
				))}
			</ul>
		);
	}
}
